import React, { useState } from 'react';

import { useHistory } from 'react-router';

import logo from '../../assets/img/logo-full.png';
import '../../assets/css/login.css';

import AlertError from './AlertError';

import { useDispatch } from 'react-redux';
import * as actions from '../../store/actions/authActions';
import { Link } from 'react-router-dom';

const Register = () => {
    const initialUserValues = {
        email: '', 
        password: '',
        confirmPassword: ''
    }

    const [user, setUser] = useState(initialUserValues);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const dispatch = useDispatch();

    const history = useHistory();

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!user.email.endsWith('@student.uj.ac.za')) {
            setErrorMessage('Not a valid student email');
            setShowError(true);
        }
        else{
            if(user.password === user.confirmPassword){
                dispatch(actions.authRegister(user));
                history.push('/account/confirmemail');
            }
            else{
                setErrorMessage('Passwords do not match');
                setShowError(true);
            }
        }
    }

    return (
        <div className="main-container">
            <div className="welcome-container">

                <img className="welcome-logo" src={logo} />

                <h2 className="welcome-title">Create Account</h2>

                <div className="welcome-form">
                    {showError ? <AlertError message={errorMessage} /> : null}

                    <form onSubmit={handleSubmit}>

                        <input 
                            type="email" 
                            name="email"
                            id="email" 
                            className="welcome-field" 
                            placeholder="Email Address"
                            onChange={e => setUser({...user, email: e.target.value})} />

                        <label htmlFor="email">Password must be 8 characters</label>

                        <input 
                            type="password" 
                            name="password" 
                            id="password" 
                            className="welcome-field" 
                            placeholder="Password"
                            onChange={e => setUser({...user,password: e.target.value})} />

                        <input 
                            type="password" 
                            name="confirm-password" 
                            id="confirm-password" 
                            className="welcome-field" 
                            placeholder="Confirm Password"
                            onChange={e => setUser({...user, confirmPassword: e.target.value})} />

                        <input name="register" id="register" style={{marginRight:'10px'}} className="welcome-btn" type="submit" value="Join" />
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Register;